// extracted by css-extract-rspack-plugin
export default {"employerOnline":"employer-online--KgiVRPuDwUkTWObo","employerOnlineMagritte":"employer-online-magritte--iiyROJ4rEW7YVMwu"};